export default {
  mounted() {
    const firstTabInput = this.$el.querySelector(".dea-tabs__header .dea-tabs__tab:first-of-type input");
    if (firstTabInput) this.selectTab(firstTabInput.getAttribute("data-item"));
  },
  methods: {
    selectTab(target) {
      const tab = document.getElementById(`tab-${target}-trigger`);
      tab.parentNode.classList.add("dea-tab-bar-single--selected");
      const event = new MouseEvent("click");
      tab.dispatchEvent(event);
    },
    openTab(event) {
      this.selectTabInTabBar(event);
      const target = event.target.getAttribute("data-target");
      this.$emit("tab-opened", target);
      const targetElement = document.getElementById(target);
      if (targetElement) {
        targetElement.classList.add("active");
        const selectors = event.target.parentNode.parentNode.querySelectorAll(".dea-tabs-single__input");
        selectors.forEach(item => {
          // eslint-disable-next-line no-param-reassign
          if (item !== event.target) item.checked = false;
        });
        const siblings = targetElement.parentNode.querySelectorAll(".dea-tabs-content");
        siblings.forEach(item => {
          if (item !== targetElement) item.classList.remove("active");
        });
      }
    },
    selectTabInTabBar(event) {
      [...document.getElementsByClassName("dea-tab-bar-single")].forEach(el =>
        el.classList.remove("dea-tab-bar-single--selected")
      );
      event.target.parentNode.classList.add("dea-tab-bar-single--selected");
    },
  },
};
